import type { FaireProductEntity } from "../../entity_types/product";

export const p_gcg9tvzctj: FaireProductEntity = {
  token: "p_gcg9tvzctj",
  type: "product",
  name: "Buena Vista Dark Roast Craft Instant Coffee",
  brandToken: "b_d3mdkn2j3h",
  brandName: "Verve Coffee Roasters",
  imageUrl: "https://cdn.faire.com/fastly/06786819011aab5a74926b9c59c0b2d69634b468d75dd3b7ecec9f62d889f1c9.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0da3bb07d49074f90bd47a4b9b8f390826778a2400b32d911406c15cea266d94.jpeg"
  ],
  priceDollars: 10,
  description: "As one of the darker roasts on our menu, Buena Vista can be characterized by its deep structure and full body. This extended roast coupled with Buena Vista’s Latin American roots yields a dark chocolate savor, caramelized sweetness, and lasting cup. Its smooth and consistent profile also makes it a very dynamic and adaptable blend that holds up well to just about every brewing device out there. So if you like waking up to a darker, richer flavor, look no further; Buena Vista will give you a dessert first mentality that won’t give you cavities and goes well with milk.\n\nAmazing things come in tiny packages. Verve Craft Instant Coffee is hand-roasted, small-batch brewed, and preserved for your adventures. Ready to be brewed wherever and whenever. A week’s worth of premium coffee in your pocket.\n\nAdd one packet of Verve Craft Instant Coffee into your mug along with 10 ounces of hot or cold liquid (water, milk, or milk alternative), stir, and drink up.\n\nMakes 6 cups of coffee.\n",
  tags: [],
  msrpDollars: 16.7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:57.399Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
